import { axiosInstance } from '~/common/utils/api.util';

import type { ApiResponse } from '~/common/types/api.type';
import type { Product } from '~/features/product/types/product.type';

/**
 * 제품 상세 조회
 * @description 제품 상세 정보를 조회합니다
 * @endpoint GET /admin/products/:id
 * @param id - 제품 ID
 * @returns 제품 정보
 */
export function getProductApi(id: number) {
  return axiosInstance.get<ApiResponse<Product>>(`/admin/products/${id}`);
}
